var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0422,
    cy: 20.3242,
    r: 20,
    fill: "var(--mg-primary-theme1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0422,
    cy: 20.3242,
    r: 20,
    fill: "var(--mg-primary-theme1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07385 16.2109H13.9795V31.2925H9.07385V16.2109ZM27.3418 16.3878C27.2897 16.3714 27.2403 16.3535 27.1855 16.3384C27.1196 16.3235 27.0533 16.3107 26.9867 16.3001C26.697 16.2408 26.4021 16.211 26.1064 16.2109C23.2464 16.2109 21.4325 18.2908 20.8347 19.0943V16.2109H15.9291V31.2925H20.8347V23.0662C20.8347 23.0662 24.5421 17.9028 26.1064 21.6952V31.2925H31.0107V21.1152C31.0087 20.0323 30.6473 18.9806 29.9834 18.1251C29.3194 17.2696 28.3903 16.6585 27.3418 16.3878Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4732 14.1542C12.7983 14.1542 13.8725 13.0799 13.8725 11.7548C13.8725 10.4297 12.7983 9.35547 11.4732 9.35547C10.1481 9.35547 9.07385 10.4297 9.07385 11.7548C9.07385 13.0799 10.1481 14.1542 11.4732 14.1542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial1);
export default __webpack_public_path__ + "static/media/social1.e33229026f49b85be7143989958fc2cb.svg";
export { ForwardRef as ReactComponent };